import { useNavigate } from 'react-router-dom';
import { UserX } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import api from '../../services/api';

export default function ImpersonationBanner() {
  const { user, setUser, isImpersonating } = useAuthStore();
  const navigate = useNavigate();

  if (!isImpersonating()) return null;

  const handleStop = async () => {
    try {
      const res = await api.post('/auth/impersonate/stop');
      if (res.data.ok) {
        setUser(res.data.data.user);
        navigate('/profesional/pacientes');
      }
    } catch (err) {
      console.error('Error al salir de impersonación:', err);
    }
  };

  return (
    <div className="bg-amber-500 text-black text-sm px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <UserX className="w-4 h-4" />
        <span>
          Estás viendo la app como <strong>{user?.username}</strong>
        </span>
      </div>
      <button
        onClick={handleStop}
        className="font-semibold underline hover:no-underline ml-4"
      >
        Volver a tu cuenta
      </button>
    </div>
  );
}
